import { memo, useRef } from 'react';
import { ReportContent, ReportHeader, ReportSearch } from '@/components/tableDrawer';
import BaseBtn from '@/components/tableDrawer/TableItems/components/tableActions/BaseBtn';
import { DateValue } from '@/components/tableDrawer';
import { ColumnsGenerator } from '@/utils/tableUtils';
//import './style.css';
import useNavs from '@/hooks/useNavs';
import { useSelectedTableItems } from '@/components/tableDrawer/reportContent/Hooks/useSelectedTableItems';
import { GetAllAMOrders } from '@/api/endpoints/AccountManager';
import { CategoryRequestCell, NameRequestCell } from './RowsCells/RowsData';
import { AttachmentsUploadedCell } from '@/pages/broker/clients/patientList/Components/RowsData';
import TableHeader from './RowsCells/TableHeader';
import Status from './RowsCells/Status/Status';

const AccountManagerMedicalRequests = () => {

    const { AccountManagerNav } = useNavs();
    const { selectedItems, handleSelected } = useSelectedTableItems()

    const refModal = useRef(null)

    const columns = [
        ColumnsGenerator.TextCell('patientName'),
        ColumnsGenerator.TextCell('brokerName'),
        ColumnsGenerator.TextCell('subCategory'),
        ColumnsGenerator.CustomCell('status', (original) => <Status status={{ name: original?.orderStatus, id: original?.orderStatusId }} />),
        ColumnsGenerator.CustomCell('orderDate', (original) => <DateValue value={original.orderDate} />),
        ColumnsGenerator.CustomCell('orderLastActivityAt',(original) => <DateValue value={original.orderLastActivityAt} />),

        ColumnsGenerator.CustomCell('action', (original) =>
            <BaseBtn onApply={() => viewRequestDetails(original)}
                title="view-details" className="details-info" reqAction="canGet" icon={"fluent:eye-16-filled"} />
        )]

    const viewRequestDetails = (original) =>
        AccountManagerNav(`/clients/patientsListGroups/viewStats/${original?.id}/${original?.orderStatusId}`)

    return (
        <>
            <TableHeader refModal={refModal} selectedItems={selectedItems} />

            <ReportContent needCheckbox handleSelected={handleSelected} tableAPI={GetAllAMOrders} columns={columns}>
                <ReportHeader  >
                    <ReportSearch />
                </ReportHeader>
            </ReportContent>
        </>
    );
}

export default memo(AccountManagerMedicalRequests);